module.exports = __webpack_public_path__ + "img/pmg2.13fdfe28.png";